import { STANDARD_EDITION } from '@atlassian/jira-shared-types/src/edition.tsx';
import type { ResourceStoreContext } from '@atlassian/react-resource-router';
import { getApplicationKeyFromProduct } from '../get-application-key-from-product/index.tsx';

export const getStandardTrialTransactionIds = (
	tenantContext: ResourceStoreContext['tenantContext'],
): string[] => {
	const cloudId = tenantContext.cloudId;
	const appEditions = tenantContext?.appEditions;

	const allEntitlementDetails = tenantContext?.productEntitlementDetails;

	if (!cloudId || !allEntitlementDetails) {
		return [];
	}

	const transactionAccountIds = Object.keys(allEntitlementDetails)
		.filter((productKey) => {
			const details = allEntitlementDetails[productKey];
			const appEditionKey = getApplicationKeyFromProduct(productKey);
			return Boolean(
				appEditionKey &&
					details.transactionAccountId &&
					details.billingSourceSystem === 'CCP' &&
					appEditions[appEditionKey] === STANDARD_EDITION &&
					Date.now() < Math.max(details.trialEndTime || 0, details.firstPredunningEndTime || 0), // in trial or pre-dunning
			);
		})
		.map((productKey) => allEntitlementDetails[productKey].transactionAccountId)
		.filter(Boolean);
	const uniqueTransactionAccountIds = Array.from(new Set(transactionAccountIds));

	return uniqueTransactionAccountIds;
};
